const getActiveVoucherCodes = (vouchers)=>{
    if (!vouchers) {
        return;
    }
    return vouchers.filter((voucher)=>voucher.isActive
    ).map((voucher)=>voucher.code
    );
};

export { getActiveVoucherCodes };
//# sourceMappingURL=get-active-voucher-codes.js.map
